export default "__VITE_ASSET__CHQH7O88__"